import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Payment API
export const paymentAPI = {
  createOrder: (productId, customerEmail, customerPhone, customerName, selectedTopic = null) =>
    api.post('/payment/create-order', {
      productId,
      customerEmail,
      customerPhone,
      customerName,
      selectedTopic
    }),

  verifyPayment: (orderId, razorpayOrderId, razorpayPaymentId, razorpaySignature) =>
    api.post('/payment/verify', {
      orderId,
      razorpayOrderId,
      razorpayPaymentId,
      razorpaySignature
    }),

  getStatus: (orderId) =>
    api.get(`/payment/status/${orderId}`)
};

export default api;
